import { useState, useEffect } from "react";
import { matchPath, useLocation } from "react-router";

/**
 * Format paths to ensure they have a leading slash
 * @param {string[]} paths - Array of paths
 * @returns {string[]} Formatted paths with leading slashes
 */
const formatPaths = (paths: string[]): string[] => {
  return paths.map((path) => {
    return path.startsWith("/") ? path : `/${path}`;
  });
};

/**
 * Hook that checks if the current path is in the hide list
 * @param {string[]} hidePaths - Paths where the chatbot should be hidden
 * @returns {boolean} True if the current path is in the hide list
 */
export const useSupportChatbotPath = (hidePaths: string[] = []): boolean => {
  const location = useLocation();
  const [isHidePath, setIsHidePath] = useState<boolean>(false);

  useEffect(() => {
    const formattedHidePaths = formatPaths(hidePaths);

    // Check if current path matches any of the hide paths
    const pathMatch = matchPath(location.pathname, formattedHidePaths);
    const shouldHide = Boolean(pathMatch);

    setIsHidePath(shouldHide);
  }, [location.pathname, hidePaths]);

  return isHidePath;
};
